/**
 * Navega para a rota especificada usando o router fornecido.
 * Se nenhum caminho de rota for fornecido, a rota padrão ('/') será navegada.
 * @param {string} routePath O caminho da rota para onde navegar.
 * @param {string} titleBreadcrumb O título a ser exibido no breadcrumb.
 * @param {boolean} shouldClear Define se o breadcrumb deve limpar seu conteúdo.
 */
const push = (routePath: string = '', forceReload: boolean = false) => {
  if (forceReload) {
    // Força um reload completo da página
    if (!routePath || routePath.trim() === '') {
      window.location.href = '/'
    } else {
      window.location.href = routePath
    }
  } else {
    // Navega usando o roteador Vue sem recarregar a página
    const router = useRouter()
    if (!routePath || routePath.trim() === '') {
      router.push('/')
    } else {
      router.push(routePath)
    }
  }
}

/**
 * Volta uma página na lista de rotas.
 * @param {Router} router O objeto do router Vue usado para navegação.
 * @param {boolean} shouldRemoveBreadcrumb Indica se deve remover um breadcrumb.
 */
const back = () => {
  const router = useRouter()
  router.back()
}

/**
 * Navega para a rota especificada usando o router fornecido.
 * Se nenhum caminho de rota for fornecido, a rota padrão ('/') será navegada.
 * @param {string} routePath O caminho da rota para onde navegar.
 * @param {string} titleBreadcrumb O título a ser exibido no breadcrumb.
 */
const backTo = (routePath: string) => {
  const router = useRouter()
  router.push(routePath)
}

export default { push, back, backTo }
